var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 8,
    viewBox: "0 0 33 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.811 4.079-1.14-2.778-1.135 2.778h2.275zm10.934 3.007-.007-5.457-2.415 5.457h-1.46l-2.424-5.463v5.463H7.052l-.64-1.554H2.944l-.647 1.554H.488L3.471.118h2.474l2.832 6.598V.118h2.719l2.18 4.726L15.678.118h2.775v6.968h-1.708zm4.36-1.425V4.274h3.656V2.852h-3.657V1.584h4.176l1.822 2.032L25.2 5.66h-4.095zm11.284 1.452h-2.165l-2.05-2.308-2.132 2.308h-6.597V.143h6.699l2.049 2.285L30.312.143h2.176L29.25 3.628l3.14 3.485z",
    fill: "#016FCF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.03ad92d34729ac57cf7cbafbf7fe0231.svg";
export { ForwardRef as ReactComponent };